// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__hw9iW","title":"Info_title__3bKKY","links":"Info_links__2Q09a","link":"Info_link__3uWCc","logo":"Info_logo__DLpQS"};